import React from 'react'
import { Routes, Route } from 'react-router-dom'
import 'antd/dist/reset.css'
import 'App.scss'
import Home from 'pages/Dashboard'
import ProductList from 'pages/Dashboard/ProductsList'
import ProductDetail from 'pages/Dashboard/ProductDetail'
import QuickOrder from 'pages/Dashboard/QuickOrder'
import Cart from 'pages/Dashboard/Cart'
import Checkout from 'pages/Dashboard/Checkout'
import Promotion from 'pages/Dashboard/Promotion'
import WishlistPage from 'pages/Dashboard/User/WishlistPage'
import Productviewed from 'pages/Dashboard/User/Productviewed'
import HistoryPurchased from 'pages/Dashboard/User/HistoryPurchased'
import Import from 'pages/Dashboard/BulkOrder/Import'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App: React.FC = () => {
  return (
    <>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/products' element={<ProductList />} />
        <Route path='/product/:slug' element={<ProductDetail />} />
        <Route path='/quick-order' element={<QuickOrder />} />
        <Route path='/promotion' element={<Promotion />} />
        <Route path='/cart' element={<Cart />} />
        <Route path='/checkout' element={<Checkout />} />
        <Route path='/wishlist' element={<WishlistPage />} />
        <Route path='/productviewed' element={<Productviewed />} />
        <Route path='/history-purchased' element={<HistoryPurchased />} />
        <Route path='/bulk-order/import' element={<Import />} />
      </Routes >
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  )
}

export default App
